import { doc, getDoc, getFirestore } from "firebase/firestore";

export default async function getNumMinted(address: string): Promise<number> {
  const db = getFirestore();
  const docRef = doc(db, "users", address);
  const docSnap = await getDoc(docRef);
  return docSnap.data()?.count ?? 0;
}
